module.exports = __webpack_public_path__ + "static/media/welcome_bg.e2bd8333.png";